import { Routes, RouterModule } from '@angular/router'
import { ModuleWithProviders } from '@angular/core'
import { AuthGuard } from '@guards/auth.guard'
import { Dashboard } from '@pages/dashboard/dashboard.component'
import { MainLayoutComponent } from '@shared/layout/app-layouts/main-layout.component'
import { AuthLayoutComponent } from '@shared/layout/app-layouts/auth-layout.component'

export const routes: Routes = [
  {
    path: 'admin/login',
    component: AuthLayoutComponent,
    loadChildren: 'app/pages/auth/login/login.module#LoginModule',
  },
  {
    path: 'admin',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: Dashboard,
      },
      {
        path: "kpi",
        data: { pageTitle: "kpi", router: true },
        loadChildren: 'app/pages/kpi/child-module/kpi/kpi.module#KpiModule',
      },
    ],
  },
]

export const routing: ModuleWithProviders = RouterModule.forChild(routes)



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts